export default {"src":"/_next/static/media/ctht.4f90a8af.svg","height":295,"width":450,"blurWidth":0,"blurHeight":0};